















































































































import { Component, Vue } from "vue-property-decorator";
import "element-ui/lib/theme-chalk/index.css";
import { HellCounting } from "@/service/HellCounting";

@Component
export default class HelloWorld extends Vue {
  private leftWeapon: string = "";
  private headgear: string = "";
  private slotWeapon: string = "";
  private weaponHold: string = "";
  private result: number = 0;
  private calculateTime: number = 1000;
  private crossNumber: string = "";
  private useAce: boolean = true;

  private testArray = ["name1", "name2", "name3"];

  mutliCalculate(): void {
    let hell = new HellCounting();
    let crossWeapon = Number(this.crossNumber);
    if (this.useAce) {
      crossWeapon += 1;
    }
    this.result = hell.calculateForTimes(
      [this.leftWeapon, this.headgear, this.slotWeapon],
      Number(this.weaponHold),
      crossWeapon,
      this.calculateTime
    );
  }
}
